import { useMutation, useQueryClient } from "@tanstack/react-query";

import { axiosInstance } from "../../lib/axios";

import { INTEGRATIONS_QUERY_KEY } from "./useFetchAllIntegrations";
import { CONNECTED_INTEGRATIONS_QUERY_KEY } from "./useFetchConnectedIntegration";

interface AzureStorageConnectRequest {
  storage_account_name: string;
  access_token: string;
}

interface AzureStorageConnectResponse {
  success: boolean;
  message: string;
  result: {
    integrationId: string;
    connected: boolean;
    connectedAt: string;
    storageAccountName: string;
  };
}

export const useAzureStorageConnect = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: AzureStorageConnectRequest) => {
      return await axiosInstance.post<AzureStorageConnectResponse>(
        "/connect/azure_storage",
        data,
      );
    },
    onSuccess: async () => {
      const promises = [
        queryClient.invalidateQueries({
          queryKey: INTEGRATIONS_QUERY_KEY(),
        }),
        queryClient.invalidateQueries({
          queryKey: CONNECTED_INTEGRATIONS_QUERY_KEY("azure_storage"),
        }),
      ];
      return Promise.all(promises);
    },
    onError: (error) => {
      console.error("Azure Storage connection failed:", error);
    },
  });
};
